import React from 'react'
import PropTypes from 'prop-types'
import strings from 'utils/strings.js'
import {
  PhaseCircle,
  PhaseCircleBackground,
  PhaseCircleOutline,
  PhaseCirclePath,
  PhaseLabel,
} from './LifeCylceButtons.style'

const noop = () => {}

const ActiveButton = ({
  isSelected,
  isSelectable,
  withLabel,
  label,
  labelTransform,
  onClick,
  transformX,
  transformY,
}) => (
  <>
    <PhaseCircle
      isSelected={isSelected}
      isSelectable={isSelectable}
      onClick={isSelectable ? onClick('promoteAction') : noop}
      transform={`translate(${transformX} ${transformY})`}
    >
      <PhaseCircleBackground
        cx="13"
        cy="12.966"
        r="12.5"
        strokeLinejoin="square"
      />
      <PhaseCircleOutline
        isSelected={isSelected}
        isSelectable={isSelectable}
        cx="13"
        cy="12.966"
        r="15"
        strokeWidth="1"
      />
      <PhaseCirclePath
        isSelected={isSelected}
        isSelectable={isSelectable}
        transform={'translate(-158 -4)'}
        strokeWidth="0.1"
        d="M178.594 12c.386 0 .718.138.993.413.275.275.413.607.413.993 0 .387-.138.718-.413.993a1.354 1.354 0 0 1-.993.414c-.106 0-.205-.012-.3-.036a1.74 1.74 0 0 1-.263-.088l-3.656 3.147v.07c0 .387-.138.718-.413.993a1.354 1.354 0 0 1-.993.413c-.387 0-.718-.134-.993-.404a1.325 1.325 0 0 1-.413-.984l-2.62-1.319a1.412 1.412 0 0 1-1.248.44c-.07-.012-.14-.03-.21-.053l-2.778 3.2a1.285 1.285 0 0 1 .106.527c0 .386-.138.718-.414.993a1.354 1.354 0 0 1-.993.413c-.386 0-.718-.138-.993-.413a1.354 1.354 0 0 1-.413-.993c0-.387.138-.718.413-.993a1.354 1.354 0 0 1 1.24-.387c.081.017.163.038.245.061l2.743-3.146a1.326 1.326 0 0 1-.141-.598c0-.386.138-.718.413-.993.275-.275.607-.413.993-.413.375 0 .695.126.958.378.264.252.407.56.43.923l2.69 1.353a1.388 1.388 0 0 1 .984-.404c.165 0 .32.03.467.088.146.058.284.135.413.228l3.427-2.953a2.404 2.404 0 0 1-.061-.22 1.354 1.354 0 0 1 .387-1.23c.275-.275.606-.413.993-.413z"
      />
    </PhaseCircle>
    {withLabel && (
      <PhaseLabel
        isSelected={isSelected}
        isSelectable={isSelectable}
        onClick={isSelectable ? onClick('promoteAction') : noop}
        fontFamily="ArialMT, Arial"
        fontSize="12"
        transform={labelTransform}
      >
        <tspan x="155.161" y="43">
          {label}
        </tspan>
      </PhaseLabel>
    )}
  </>
)

ActiveButton.defaultProps = {
  withLabel: true,
  label: strings.active,
  transformX: 158,
  transformY: 4,
  labelTransform: 'translate(0 4)',
}

ActiveButton.propTypes = {
  isSelected: PropTypes.bool,
  isSelectable: PropTypes.bool,
  isDisabled: PropTypes.bool,
  withLabel: PropTypes.bool,
  label: PropTypes.string,
  onClick: PropTypes.func,
  transformX: PropTypes.number,
  transformY: PropTypes.number,
  labelTransform: PropTypes.string,
}

export default ActiveButton
